import { Tag } from '@zillow/constellation-10';
import type { PropertyEliseDto } from '@zg-rentals/ts-ad-management-client';

export type EliseProperty = PropertyEliseDto;

const CONNECTED_CONFIG = { label: 'Connected', tone: 'green' } as const;
const DISCONNECTED_CONFIG = { label: 'Disconnected', tone: 'gray' } as const;

export const EliseAiStatusTag = ({ property }: { property: EliseProperty }) => {
  const config = property.isEliseAiPropertyEnabled ? CONNECTED_CONFIG : DISCONNECTED_CONFIG;

  return <Tag tone={config.tone}>{config.label}</Tag>;
};
